// react
import React from "react";
import theme from "../../data/theme";
import FooterMobileSticky from "./FooterMobileSticky";

export default function FooterContacts() {
  return (
     <>
    <div className="site-footer__widget footer-contacts">
      {/* <img src="images/footerlogo1.png" alt="Footer Logo" /> */}

      <div className="footer-contacts__text">
        Dubai's fast-growth market, world-class infrastructure and
        business-friendly environment make it ideal for entrepreneurs and
        investors.
      </div>

      <ul className="footer-contacts__contacts">
        <li>
          <i className="footer-contacts__icon fas fa-globe-americas" />
          {theme.contacts.address}
        </li>
        <li>
          <i className="footer-contacts__icon far fa-envelope" />
          {theme.contacts.email}
        </li>
        {/* <li>
                    <i className="footer-contacts__icon fas fa-mobile-alt" />
                    {`${theme.contacts.phone}, ${theme.contacts.phone}`}
                </li>
                <li>
                    <i className="footer-contacts__icon far fa-clock" />
                    Mon-Sat 10:00pm - 7:00pm
                </li> */}
      </ul>
    </div>

     <FooterMobileSticky />
    </>
  );
}
